// extracted by mini-css-extract-plugin
module.exports = {"blocks":"default-block-styles_blocks__Hw60V","full":"default-block-styles_full__OAvuz"};